import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Box, Text } from '@theme-ui/components';

import { Button } from '@app/components/Button';
import { rem } from '@app/styles/theme/layout';

import { ORDER_RETURN_REQUEST_FAST_TRACK_PERIOD } from '../constants';
import messages from '../ReturnRequest.messages';

const AdditionalReviewProccesInfo = ({
  onContinue,
}: {
  onContinue: () => void;
}) => {
  const { language } = useParams<{ language?: string }>();
  const orderSupportLink = `https://support.native-instruments.com/hc/${language}/articles/209568149-I-Would-Like-a-Refund-for-a-Purchase-Made-In-the-Webshop`;
  return (
    <>
      <Text sx={{ fontWeight: 'bold' }}>
        <FormattedMessage
          {...messages.orderReturnAdditionalReview}
          values={{
            period: ORDER_RETURN_REQUEST_FAST_TRACK_PERIOD,
          }}
        />
      </Text>
      <Text mt={16} sx={{ display: 'block' }}>
        <FormattedMessage
          {...messages.orderReturnSupportInfo}
          values={{
            supportLinkName: (
              <a
                href={orderSupportLink}
                target="_blank"
                rel="noreferrer noopener"
              >
                <FormattedMessage {...messages.orderReturnSupportLink} />
              </a>
            ),
          }}
        />
      </Text>
      <Box
        sx={{
          justifyContent: 'end',
          display: 'flex',
          marginTop: rem(32),
        }}
      >
        <Button
          type="primary"
          data-testid="return-request-continue-button"
          onClick={onContinue}
        >
          <FormattedMessage {...messages.continueToReturnRequest} />
        </Button>
      </Box>
    </>
  );
};

export default AdditionalReviewProccesInfo;
